import { api } from '@/lib/api/client'
import type { ApiUser, LoginResult } from '../model/types'

export const authApi = {
  login(identifier: string, password: string) {
    return api.post<LoginResult>('/auth/login', { identifier, password })
  },
  register(input: { fullName: string; username: string; email: string; phone: string; password: string }) {
    return api.post<LoginResult>('/auth/register', input)
  },
  me() {
    return api.get<ApiUser>('/auth/me')
  },
  refresh(refreshToken: string) {
    return api.post<{ accessToken: string; refreshToken: string }>('/auth/refresh', { refreshToken })
  },
}
